import { zodResolver } from "@hookform/resolvers/zod";
import { useMemo, useRef, useState } from "react"
import { useForm, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  getRequiredFields,
} from "@/lib/utils";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import {
  DOCUMENT_NO,
  HIDE_ZERO_BALANCES,
  INCLUDE_PERIOD_0,
  SHOW_LONG_DESCRIPTION,
} from "./consts";
import { formValues, schema } from "./validations";

const useDisplayAccountingDocument = () => {
  const selectedDoc = useRef<any>(null);
  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const currentFinanceYear = useSelector(
    (state: RootState) => state.currentData.currentFinanceYear
  );

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [DOCUMENT_NO]: "",
      [INCLUDE_PERIOD_0]: false,
      [HIDE_ZERO_BALANCES]: false,
      [SHOW_LONG_DESCRIPTION]: false,
    },
  });
  
  const docNo = useWatch({ control: form.control, name: DOCUMENT_NO });

  const [isRunClicked, setIsRunClicked] = useState(false);

  const breadcrumbData = useMemo(
    () => [
      {
        link: `/${routes.admin}/${routes.activityDashboard}`,
        name: `Activity Dashboard - ${communityData?.name || ""}`,
      },
      {
        link: "",
        name: <span className="text-primary">Display Accounting Document</span>,
      },
    ],
    []
  );

  const requiredFields = getRequiredFields(schema);

  const onSubmit = () => {
    selectedDoc.current = { postDocHeaderId: docNo, communityId: communityData?.communityId }
    setIsRunClicked(true);
  };

  return {
    breadcrumbData,
    form,
    requiredFields,
    onSubmit,
    selectedDoc: selectedDoc.current,
    currentFinanceYear,
    isRunClicked
  };
};

export default useDisplayAccountingDocument;
